import { Controller } from "@hotwired/stimulus"
import { formatValue as formatFieldValue } from "web/services/format"

export default class NumberFormatController extends Controller {
  static targets = ["display", "hidden"]
  static values = { format: String, kind: String, unit: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const raw = this.hiddenTarget.value

    if (raw === "") {
      this.displayTarget.type = "text"
      this.displayTarget.value = ""
      return
    }

    if (this.formatValue === "Percent") return

    this.displayTarget.type = "text"
    this.displayTarget.value = formatFieldValue({
      value: raw,
      kind: this.kindValue,
      format: this.formatValue,
      unit: this.unitValue || undefined,
    })
  }

  showRaw() {
    this.displayTarget.type = "number"
    this.displayTarget.step = "any"
    this.displayTarget.value = this.hiddenTarget.value
  }

  sync() {
    this.hiddenTarget.value = this.displayTarget.value
  }
}
